import { DashboardOutlined, TableChartOutlined } from "@mui/icons-material";
import { Stack, ToggleButtonGroup } from "@mui/material";
import { TooltipToggleButton } from "./TooltipToggleButton";

interface Props {
  isTableView: boolean;
  fontSize?: "small" | "medium" | "large";
  variant?: "menu" | "tertiary";
  onViewToggled: (isTableView: boolean) => void;
}

const ViewToggleButtonGroup = (props: Props) => {
  return (
    <Stack direction="row" spacing={1} sx={{
      alignItems: "center"
    }}>
      <ToggleButtonGroup
        variant={props.variant}
        value={props.isTableView}
        color="primary"
        size="small"
        exclusive
        onChange={(_, value: boolean) => {
          if (value != null) {
            props.onViewToggled(value);
          }
        }}
      >
        <TooltipToggleButton title="Table View" value={true}>
          <TableChartOutlined fontSize={props.fontSize ?? "large"} />
        </TooltipToggleButton>

        <TooltipToggleButton title="Board View" value={false}>
          <DashboardOutlined fontSize={props.fontSize ?? "large"} />
        </TooltipToggleButton>
      </ToggleButtonGroup>
    </Stack>
  );
};

export { ViewToggleButtonGroup };
